import { brandAssets } from "@/lib/brandAssets";
import { cn } from "@/lib/utils";

type Variant = "color" | "mono";

type BrandLogoProps = {
  variant?: Variant;
  className?: string;
  alt?: string;
};

export function BrandLogo({
  variant = "color",
  className,
  alt = "FamChest 傳琛",
}: BrandLogoProps) {
  const src = variant === "mono" ? brandAssets.logoMono : brandAssets.logoLarge;
  return (
    <img
      src={src}
      alt={alt}
      className={cn("h-10 w-auto sm:h-12 lg:h-14", className)}
      loading="eager"
      decoding="async"
    />
  );
}
